import { ConversationProblemsDisplay, ApiConversationProblem } from "@tt-app/models/exercise";

/**
 * Load chat problems items for a specific retryCount value and optionally display hints
 *
 * @param problem
 * @param retryCount
 */
export const getConversationProblemDisplay = (
  problem: ApiConversationProblem,
  retryCount = 0
): ConversationProblemsDisplay => {
  const inQueue = problem.attempts[retryCount].components;
  const hints =
    problem.attempts[retryCount].showHints && problem.hints && problem.hints.length
      ? problem.hints[0].words
      : [];

  return { inQueue, hints };
};
